import React, { useCallback, useEffect } from "react";
import "./App.css";
import LayoutContainer from "./containers/Layout";
import { connect } from "react-redux";
import { sagaGetEstilosInterno, sagaGetEstilosOnline } from "./reducers/sessionReducer/actions";
import { estilosInternoSelector, estilosOnlineSelector } from "./selectors/sessionSelector";

const App = ({ dispatch, estilosInterno, estilosOnline }) => {
  useEffect(() => {
    dispatch(sagaGetEstilosInterno());
    dispatch(sagaGetEstilosOnline());
  }, [dispatch]);

  const recargarEstilos = useCallback(() => {
    if (estilosInterno) {
      document.documentElement.style.setProperty(
        "--top-menu-backgroundcolor",
        estilosInterno.topMenuBackgroundcolor
      );
      document.documentElement.style.setProperty("--button-primary", estilosInterno.buttonPrimary);
      document.documentElement.style.setProperty(
        "--button-secondary",
        estilosInterno.buttonSecondary
      );
      document.documentElement.style.setProperty(
        "--button-secondary-hover",
        estilosInterno.buttonSecondaryHover
      );
      document.documentElement.style.setProperty("--button-success", estilosInterno.buttonSuccess);
      document.documentElement.style.setProperty(
        "--button-success-hover",
        estilosInterno.buttonSuccessHover
      );
      document.documentElement.style.setProperty(
        "--turnos-itemdia-background",
        estilosInterno.turnosItemdiaBackground
      );
      document.documentElement.style.setProperty("--border-config", estilosInterno.borderConfig);
      document.documentElement.style.setProperty("--item-config", estilosInterno.itemConfig);
    }
    if (estilosOnline) {
      document.documentElement.style.setProperty(
        "--footer-backgroundcolor",
        estilosOnline.footerBackgroundcolor
      );
      document.documentElement.style.setProperty(
        "--footer-desarrollado-por-backgroundcolor",
        estilosOnline.footerDesarrolladoPorBackgroundcolor
      );
      document.documentElement.style.setProperty(
        "--container-turnero-background",
        estilosOnline.containerTurneroBackground
      );
      document.documentElement.style.setProperty(
        "--container-turnero-border",
        estilosOnline.containerTurneroBorder
      );
      document.documentElement.style.setProperty(
        "--container-turnero-item-horario",
        estilosOnline.containerTurneroItemHorario
      );
      document.documentElement.style.setProperty(
        "--online-links-and-buttons",
        estilosOnline.LinksAndButtons
      );
      document.documentElement.style.setProperty(
        "--online-information-box-color",
        estilosOnline.InformationBoxColor
      );
    }
  }, [estilosInterno, estilosOnline]);

  useEffect(() => {
    recargarEstilos();
  }, [recargarEstilos]);

  return <LayoutContainer />;
};

const mapStateToProps = (state) => ({
  estilosInterno: estilosInternoSelector(state),
  estilosOnline: estilosOnlineSelector(state),
});

export default connect(mapStateToProps)(App);
